// Firebase Init
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { OAuthProvider, GoogleAuthProvider, getAuth, onAuthStateChanged, signInWithPopup } from "firebase/auth";

// Firebase config
const firebaseConfig = {
   apiKey: "AIzaSyCuFk4XADy2yZ7XZqwrYGXIUta-SFEgI0M",
   authDomain: "fbdapp-wpi.firebaseapp.com",
   projectId: "fbdapp-wpi",
   storageBucket: "fbdapp-wpi.appspot.com",
   messagingSenderId: "715011808667",
   appId: "1:715011808667:web:7c2c0eb2b8f76d8513553e"
};

// Initialize Firebase
const fb = initializeApp(firebaseConfig);
const auth = getAuth(fb);
const googleProvider = new GoogleAuthProvider();
const msProvider = new OAuthProvider("microsoft.com");

const signIn = () => {
   signInWithPopup(auth, provider).then( (res) => {
      console.log("Signed in!");
   }).catch(err => {
      console.log("Error signing in!");
      console.error(err);
   });
};

export const fbdAuthProps = {
   auth,
   googleSignIn: () => signInWithPopup(auth, googleProvider),
   msSignIn: () => signInWithPopup(auth, msProvider),
   onAuthChange: (lm) => {
      onAuthStateChanged(auth, lm)
   }
};